import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateInspectionServiceMetadata } from '../../api/inspection-service.ts';
import { UpdateInspectionServiceMetadataRequest } from '../../api/requests/inspection-service-request.ts';

export default function useUpdateInspectionServiceMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateInspectionServiceMetadata>>,
  Error,
  UpdateInspectionServiceMetadataRequest
> {
  return useMutation({
    mutationFn: updateInspectionServiceMetadata,
  });
}
